import { useEffect, useState } from "react";
import { HitLoadingBlock } from "@/components/loading";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { FileText, Edit2 } from "lucide-react";
import LegalContent from "@/components/LegalContent";
import { Seo } from "@/components/Seo";

export default function Legal() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [doc, setDoc] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ title: "", content: "" });

  useEffect(() => {
    api.get(`/legal/${slug}`).then((r) => {
      setDoc(r.data);
      setForm({ title: r.data.title, content: r.data.content });
    });
  }, [slug]);

  const save = async () => {
    await api.put(`/admin/legal/${slug}`, form);
    toast.success("Guardado");
    setDoc({ ...doc, ...form });
    setEditing(false);
  };

  if (!doc) return <div className="max-w-3xl mx-auto px-5 py-8 min-h-[70vh]"><HitLoadingBlock section="legal" /></div>;

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <Seo
        title={doc.title}
        description={`${doc.title} — HitTCG. Documento legal aplicable al marketplace ecuatoriano de cartas Pokémon y Riftbound.`}
        url={`/legal/${slug}`}
      />
      <div className="flex items-center gap-3 mb-4">
        <FileText size={28} className="text-[#EF4444]" />
        {editing ? (
          <Input value={form.title} onChange={(e) => setForm(f => ({ ...f, title: e.target.value }))} className="bg-[#171717] border-[#262626] font-display text-2xl" />
        ) : (
          <h1 className="font-display text-3xl">{doc.title}</h1>
        )}
      </div>
      {user?.role === "admin" && !editing && (
        <Button data-testid="legal-edit" onClick={() => setEditing(true)} variant="ghost" className="text-[#EF4444] mb-4"><Edit2 size={14} className="mr-1" />Editar</Button>
      )}
      {editing ? (
        <div className="space-y-3">
          <Textarea data-testid="legal-content" value={form.content} onChange={(e) => setForm(f => ({ ...f, content: e.target.value }))} rows={12} className="bg-[#171717] border-[#262626] font-mono text-sm" />
          <div className="flex gap-2">
            <Button data-testid="legal-save" onClick={save} className="bg-[#EF4444] hover:bg-[#DC2626]">Guardar</Button>
            <Button variant="ghost" onClick={() => setEditing(false)}>Cancelar</Button>
          </div>
        </div>
      ) : (
        <LegalContent content={doc.content} />
      )}
    </div>
  );
}
